<template>
  <AppHeader
    :is_icon="false"
    :is_back="true"
    :title="''"
    :type="isEntry ? 'skip_icon' : 'none'"
    @header-action-click="headerActionClick"
  />
  <div class="user-edit-detail" ref="scrollContainer" style="overflow-y: auto">
    <div class="page">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div style="padding: 0 8px">
              <div style="padding-bottom: 15px" v-show="isEntry">
                <div
                  class="progress"
                  role="progressbar"
                  aria-label="Basic example"
                  aria-valuenow="0"
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  <div
                    class="progress-bar"
                    :style="
                      'background-color: #784ba0 !important; width: ' +
                      count +
                      '%'
                    "
                  ></div>
                </div>
              </div>
              <div>
                <div
                  style="
                    padding-top: 0px;
                    padding-bottom: 10px;
                    font-size: 20px;
                    font-weight: bold;
                    color: #827490;
                  "
                >
                  フェチズム
                </div>
                <div
                  style="
                    padding: 10px 20px;
                    font-size: 12px;
                    font-weight: 400;
                    background-color: rgb(244, 245, 247);
                    border-radius: 6px;
                  "
                >
                  あなたのフェチズムを教えてください<br />
                  1:全く当てはまらない<br />
                  2:当てはまらない<br />
                  3:あまり当てはまらない<br />
                  4:やや当てはまる<br />
                  5:当てはまる<br />
                  6:とても当てはまる
                </div>
              </div>
              <div class="item-box">
                <hr />
                <div v-for="(item, i) in this.questionList" :key="i">
                  <div class="item-title">
                    {{ item.label }}&nbsp;
                    <svg
                      ref="tooltipIcons"
                      xmlns="http://www.w3.org/2000/svg"
                      height="16px"
                      viewBox="0 -960 960 960"
                      width="16px"
                      fill="currentColor"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      :title="item.comment"
                    >
                      <path
                        d="M478-240q21 0 35.5-14.5T528-290q0-21-14.5-35.5T478-340q-21 0-35.5 14.5T428-290q0 21 14.5 35.5T478-240Zm-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
                      />
                    </svg>
                  </div>
                  <div style="padding: 10px 0">
                    <v-slider
                      v-model="item.value"
                      color="#784ba0"
                      :max="6"
                      :min="1"
                      show-ticks="always"
                      :ticks="tickLabels"
                      :step="1"
                    ></v-slider>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    style="
      position: fixed;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 75px;
      padding: 5px 20px;
      background-color: #fff;
    "
  >
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8" style="height: 65px">
          <button
            type="button"
            style="width: 100%; height: 40px"
            class="btn btn-kinkyer m-plus-medium"
            @click="((isEdit = true), update())"
          >
            {{ btnName }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="d-none d-md-block"
    style="position: fixed; top: 0px; width: 100%; height: 100%; z-index: -1"
  >
    <div class="container" style="height: 100%">
      <div class="row" style="height: 100%">
        <div
          class="col-2"
          style="height: 100%; padding: 0; border-right: solid 1px #f3f3f3"
        ></div>
        <div class="col-8"></div>
        <div
          class="col-2"
          style="height: 100%; padding: 0; border-left: solid 1px #f3f3f3"
        ></div>
      </div>
    </div>
  </div>
  <div
    v-show="isEdit"
    style="
      position: fixed;
      top: 0px;
      width: 100%;
      height: 100%;
      background-color: rgb(0 0 0 / 50%);
      margin: 0 auto;
      padding-top: 200px;
      text-align: center;
      z-index: 999;
    "
  >
    <div style="position: absolute; z-index: 9999; width: 100%">
      <VueSpinnerBars size="50" color="#fff" />
    </div>
  </div>
</template>

<script>
import { nextTick } from "vue";
import AppHeader from "@/components/HeaderView.vue";
import { db } from "../../../plugins/firebase";
import { doc, updateDoc } from "firebase/firestore";
import { store, setUser } from "../../../plugins/store";
import { Tooltip } from "bootstrap";

export default {
  data() {
    return {
      isEdit: false,
      isEntry: true,
      uid: "",
      user: {},
      sadistic: 1,
      count: 0,
      tickLabels: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
      },
      questionList: {
        question1: {
          label: "匂い",
          column: "question1",
          value: 1,
          comment: "体臭や香水の匂いに惹かれる",
        },
        question2: {
          label: "体液・血",
          column: "question2",
          value: 1,
          comment: "唾液や血などに性的興奮を感じる",
        },
        question3: {
          label: "唇",
          column: "question3",
          value: 1,
          comment: "唇の形や感触に魅力を感じる",
        },
        question4: {
          label: "声",
          column: "question4",
          value: 1,
          comment: "話し声や息遣いに興奮する",
        },
        question5: {
          label: "お尻",
          column: "question5",
          value: 1,
          comment: "お尻の形や動きに惹かれる",
        },
        question6: {
          label: "胸",
          column: "question6",
          value: 1,
          comment: "胸の大きさや形に魅力を感じる",
        },
        question7: {
          label: "手・指",
          column: "question7",
          value: 1,
          comment: "指先や仕草に惹かれる",
        },
        question8: {
          label: "腕",
          column: "question8",
          value: 1,
          comment: "腕の太さや筋に魅力を感じる",
        },
        question9: {
          label: "太腿",
          column: "question9",
          value: 1,
          comment: "太腿の柔らかさや曲線が好き",
        },
        question10: {
          label: "鼠蹊部",
          column: "question10",
          value: 1,
          comment: "脚の付け根部分に惹かれる",
        },
        question11: {
          label: "腰",
          column: "question11",
          value: 1,
          comment: "腰のくびれや動きに興奮する",
        },
        question12: {
          label: "耳",
          column: "question12",
          value: 1,
          comment: "耳の形や感触に惹かれる",
        },
        question13: {
          label: "首",
          column: "question13",
          value: 1,
          comment: "首筋や喉仏に魅力を感じる",
        },
        question14: {
          label: "筋肉",
          column: "question14",
          value: 1,
          comment: "引き締まった筋肉に惹かれる",
        },
        question15: {
          label: "骨格・鎖骨",
          column: "question15",
          value: 1,
          comment: "骨のラインや鎖骨が好き",
        },
        question16: {
          label: "髪の毛",
          column: "question16",
          value: 1,
          comment: "髪の質感や匂いに惹かれる",
        },
        question64: {
          label: "黒子（ほくろ）",
          column: "question64",
          value: 1,
          comment: "ほくろの位置や数に魅力を感じる",
        },
        question65: {
          label: "ラバー",
          column: "question65",
          value: 1,
          comment: "ラバー素材の質感に興奮する",
        },
        question66: {
          label: "ウェット&メッシー",
          column: "question66",
          value: 1,
          comment: "濡れたり汚れることに快感を覚える",
        },
        question67: {
          label: "ケモナー",
          column: "question67",
          value: 1,
          comment: "動物的特徴のある姿に惹かれる",
        },
        question68: {
          label: "オブジェクトフィリア（対物性愛）",
          column: "question68",
          value: 1,
          comment: "無機物に愛情や欲望を感じる",
        },
      },
    };
  },
  watch: {
    // データが変更されたときにスクロールをリセット
    content: {
      async handler() {
        await nextTick();
        if (this.$refs.scrollContainer) {
          window.scrollTo(0, 0);
        }
      },
      immediate: true,
    },
  },
  async created() {
    this.count = 3.846 * 23;
    this.isEntry = this.$route.params.type != "mod";
    this.btnName = this.$route.params.type == "mod" ? "保存する" : "次へ";

    this.user = store.user;
  },
  mounted() {
    this.$refs.tooltipIcons?.forEach((el) => {
      new Tooltip(el);
    });
    this.questionList.question1.value =
      this.user.question1 == undefined ? 0 : this.user.question1;
    this.questionList.question2.value =
      this.user.question2 == undefined ? 0 : this.user.question2;
    this.questionList.question3.value =
      this.user.question3 == undefined ? 0 : this.user.question3;
    this.questionList.question4.value =
      this.user.question4 == undefined ? 0 : this.user.question4;
    this.questionList.question5.value =
      this.user.question5 == undefined ? 0 : this.user.question5;
    this.questionList.question6.value =
      this.user.question6 == undefined ? 0 : this.user.question6;
    this.questionList.question7.value =
      this.user.question7 == undefined ? 0 : this.user.question7;
    this.questionList.question8.value =
      this.user.question8 == undefined ? 0 : this.user.question8;
    this.questionList.question9.value =
      this.user.question9 == undefined ? 0 : this.user.question9;
    this.questionList.question10.value =
      this.user.question10 == undefined ? 0 : this.user.question10;
    this.questionList.question11.value =
      this.user.question11 == undefined ? 0 : this.user.question11;
    this.questionList.question12.value =
      this.user.question12 == undefined ? 0 : this.user.question12;
    this.questionList.question13.value =
      this.user.question13 == undefined ? 0 : this.user.question13;
    this.questionList.question14.value =
      this.user.question14 == undefined ? 0 : this.user.question14;
    this.questionList.question15.value =
      this.user.question15 == undefined ? 0 : this.user.question15;
    this.questionList.question16.value =
      this.user.question16 == undefined ? 0 : this.user.question16;
    this.questionList.question64.value =
      this.user.question64 == undefined ? 0 : this.user.question64;
    this.questionList.question65.value =
      this.user.question65 == undefined ? 0 : this.user.question65;
    this.questionList.question66.value =
      this.user.question66 == undefined ? 0 : this.user.question66;
    this.questionList.question67.value =
      this.user.question67 == undefined ? 0 : this.user.question67;
    this.questionList.question68.value =
      this.user.question68 == undefined ? 0 : this.user.question68;
  },
  components: {
    AppHeader,
  },
  methods: {
    async update() {
      try {
        const docUpdateUsersRef = doc(db, "users", this.user.uid);

        await updateDoc(docUpdateUsersRef, {
          question1: this.questionList.question1.value,
          question2: this.questionList.question2.value,
          question3: this.questionList.question3.value,
          question4: this.questionList.question4.value,
          question5: this.questionList.question5.value,
          question6: this.questionList.question6.value,
          question7: this.questionList.question7.value,
          question8: this.questionList.question8.value,
          question9: this.questionList.question9.value,
          question10: this.questionList.question10.value,
          question11: this.questionList.question11.value,
          question12: this.questionList.question12.value,
          question13: this.questionList.question13.value,
          question14: this.questionList.question14.value,
          question15: this.questionList.question15.value,
          question16: this.questionList.question16.value,
          question64: this.questionList.question64.value,
          question65: this.questionList.question65.value,
          question66: this.questionList.question66.value,
          question67: this.questionList.question67.value,
          question68: this.questionList.question68.value,
        });

        this.user.question1 = this.questionList.question1.value;
        this.user.question2 = this.questionList.question2.value;
        this.user.question3 = this.questionList.question3.value;
        this.user.question4 = this.questionList.question4.value;
        this.user.question5 = this.questionList.question5.value;
        this.user.question6 = this.questionList.question6.value;
        this.user.question7 = this.questionList.question7.value;
        this.user.question8 = this.questionList.question8.value;
        this.user.question9 = this.questionList.question9.value;
        this.user.question10 = this.questionList.question10.value;
        this.user.question11 = this.questionList.question11.value;
        this.user.question12 = this.questionList.question12.value;
        this.user.question13 = this.questionList.question13.value;
        this.user.question14 = this.questionList.question14.value;
        this.user.question15 = this.questionList.question15.value;
        this.user.question16 = this.questionList.question16.value;
        this.user.question64 = this.questionList.question64.value;
        this.user.question65 = this.questionList.question65.value;
        this.user.question66 = this.questionList.question66.value;
        this.user.question67 = this.questionList.question67.value;
        this.user.question68 = this.questionList.question68.value;

        setUser(this.user, this.user.uid);

        if (this.$route.params.type == "mod") {
          this.$router.go(-1);
        } else {
          this.$router.push("/user/edit/bdsm/" + this.$route.params.type);
        }
      } catch (error) {
        this.isEdit = false;
        console.error("Error :", error);

        this.$toast.show("登録時にエラーが発生しました", {
          type: "error",
          position: "bottom",
          duration: 2000,
        });
        return;
      }
    },
    headerActionClick(data) {
      if (data == "skip_icon") {
        this.update();
      }
    },
  },
};
</script>

<style scoped>
.user-edit-detail {
  animation: fadeIn 1.2s cubic-bezier(0.33, 1, 0.68, 1) 1 forwards;
  height: 100%;
}
.page {
  padding-top: 80px;
  padding-bottom: 80px;
}
.item-box {
  padding-bottom: 20px;
}
.item-title {
  font-size: 14px;
  font-weight: 600;
  padding-top: 10px;
  align-items: center;
  display: flex;
}
.item-subtitle {
  font-size: 12px;
  font-weight: 600;
}
.item-description {
  font-size: 12px;
  font-weight: 400;
}
</style>
